import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";

export const useRecalculateSeries = (options: UseMutationOptions<unknown, unknown, string> = {}) => {
  const request = useApi();

  const { sport, organizationId, seasonId } = useParams();

  return useMutation({
    mutationFn: (seriesCode: string) =>
      request(`${sport}/o/${organizationId}/seasons/${seasonId}/series/${seriesCode}/calculate`, {
        method: "POST",
      }),
    ...options,
  });
};
